import { Grid } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

export interface GenericCardGridProps {
  children: React.ReactNode;
  columns?: number | { xs?: number; sm?: number; md?: number; lg?: number };
  gap?: number | string;
  className?: string;
}

const GenericCardGridImpl: React.FC<GenericCardGridProps> = ({
  children,
  columns = { xs: 1, sm: 2, md: 3, lg: 3 },
  gap = 2,
  className,
}) => {
  // Convert columns prop to Grid format
  const gridColumns =
    typeof columns === 'number'
      ? {
          xs: 1,
          sm: Math.min(columns, 2),
          md: Math.min(columns, 3),
          lg: columns,
        }
      : { xs: 1, sm: 2, md: 3, lg: 3, ...columns };

  return (
    <Grid container spacing={gap} className={className}>
      {React.Children.map(children, (child, index) => (
        <Grid
          item
          key={index}
          xs={gridColumns.xs}
          sm={gridColumns.sm}
          md={gridColumns.md}
          lg={gridColumns.lg}
        >
          {child}
        </Grid>
      ))}
    </Grid>
  );
};

export const GenericCardGrid = muiStyled(GenericCardGridImpl)(
  ({ theme }) => css`
    width: 100%;
  `
);
